/// \file popupFormatter.tsx
///
/// \par Copyright Notice:
/// Copyright (c) 2023 by Oshkosh Corporation.
/// All Rights Reserved.
///
/// \par
/// The information contained herein is confidential and proprietary property
/// of Oshkosh Corporation, and may be privileged.  The dissemination,
/// distribution, use, copying, transfer, or disclosure of such information is
/// strictly prohibited except by express written agreement with Oshkosh
/// Corporation, or with one of its subsidiaries.

import React, { Fragment } from 'react';
import { SearchDropdownBar } from '../../../components/filter/searchDropdownBar';
import { MultiSelectDropdownBar } from '../../../components/filter/multiSelectDropdownBar';

export const PopupFormatter = (props:{
  id:string,
  pairs:any,
  onInputChange:(e:any)=>void,
}) => {
  const id = props.id;
  const pairs= props.pairs;
  const onInputChange = props.onInputChange;

  const onTimeClear = () => {
    console.log("Why is this getting triggered?");
  };

    return(
    <Fragment>
        <div className={id+"-contents"}>
            {pairs.map((pair:any, index:number) => <FilterElement key={pair.id+"-"+pair.name + index.toString()} id={id} pair={pair} onTimeClear={onTimeClear} onInput={onInputChange} />)}
        </div>
    </Fragment>
    );
};

function FilterElement(props:{
  pair:{
    style:string,
    name:string,
    title:string,
    values:any,
    // values:{
    //   data:any[],
    //   onChange:(e:any)=>void,
    //   onFilterChange:(e:any)=>void,
    //   startValue:any,
    //   placeholder:string
    // }
  },
  id:string,
  onTimeClear:null|((e:any)=>void),
  onInput:((e:any)=>void)
}) {
  const pair = props.pair;
  const id = props.id;
  const onTimeClear = props.onTimeClear;
  if(pair.style=="input"){
    return(
      <div className={id+"-"+pair.name+"-dropdown"}>
        <div className={id+"-dropdown-title"}>{pair.title}</div>
        <input className={id+"-input"} type="text" id={id+"-"+pair.name+"-input"} onChange={props.onInput} defaultValue={pair.values.startValue}></input>
      </div>
    );
  }else if(pair.style=="number"){
    return(
      <div className={id+"-"+pair.name+"-dropdown"}>
        <div className={id+"-dropdown-title"}>{pair.title}</div>
        <input className={id+"-input"} type="number" id={id+"-"+pair.name+"-input"} onChange={props.onInput} defaultValue={pair.values.startValue}></input>
      </div>
    );
  }else if(pair.style=="password"){
    const compareWith = id+"-"+pair.name
    console.log("password values: ",compareWith)
    if(compareWith=="popup-password-newPassword"){
      return(<div className={id+"-"+pair.name+"-dropdown"}>
        <div className={id+"-dropdown-title"}>{pair.title}</div>
        <input className={id+"-input"} type="password" id={id+"-"+pair.name+"-input"} onBlur={pair.values.onBlur} onChange={pair.values.popupHelper} onClick={pair.values.popupHelper} defaultValue={pair.values.startValue} autoComplete="off"></input>
            <div id="userInputPasswordTeller" className={pair.values.passwordPopup?"showMeChange":"hideMe"}>
              <div id="userInputPasswordTellerLength" className="notValid">
              <span id="userInputPasswordTellerLengthShape" className="redFaultCircle">
                {'\u2717'}
              </span>
              Must Contain At Least 8 Characters
              </div>
              <div id="userInputPasswordTellerFirst" className="notValid">
              <span id="userInputPasswordTellerFirstShape" className="redFaultCircle">
                {'\u2717'}
              </span>
                First Character Must be a Letter
              </div>
              <div id="userInputPasswordTellerNumeric" className="notValid">
              <span id="userInputPasswordTellerNumericShape" className="redFaultCircle">
                {'\u2717'}
              </span>
                Must Contain At Least 1 Numeric Characters
              </div>
              <div id="userInputPasswordTellerLower" className="notValid">
              <span id="userInputPasswordTellerLowerShape" className="redFaultCircle">
                {'\u2717'}
              </span>
                Must Contain At Least 1 Lower Case character
              </div>
              <div id="userInputPasswordTellerUpper" className="notValid">
              <span id="userInputPasswordTellerUpperShape" className="redFaultCircle">
                {'\u2717'}
              </span>
                Must Contain At Least 1 Upper Case character
              </div>
              <div id="userInputPasswordTellerSpecial" className="notValid">
              <span id="userInputPasswordTellerSpecialShape" className="redFaultCircle">
                {'\u2717'}
              </span>
                Must Contain At Least 1 Special Character (!,*,%,_,#,$,@)
              </div>
            </div>
        <button className={id+"-"+pair.name+" visibility-button k-icon k-i-preview strike"} id={id+"-"+pair.name} onClick={pair.values.onChange}></button>
      </div>)
    }
    else{
      console.log("did not match")
    }
    return(
      <div className={id+"-"+pair.name+"-dropdown"}>
        <div className={id+"-dropdown-title"}>{pair.title}</div>
        <input className={id+"-input"} type="password" id={id+"-"+pair.name+"-input"} onChange={props.onInput} defaultValue={pair.values.startValue} autoComplete="off"></input>
        <button className={id+"-"+pair.name+" visibility-button k-icon k-i-preview strike"} id={id+"-"+pair.name} onClick={pair.values.onChange}></button>
      </div>
    );
  }
  else if(pair.style=="single-select"){
    return(
      <div className={id+"-"+pair.name+"-dropdown"}>
        <div className={id+"-dropdown-title"}>{pair.title}</div>
        <SearchDropdownBar
          id = {id+"-"+pair.name+"-dropdown-combobox"}
          onFilterChange={pair.values.onFilterChange}
          onChange={pair.values.onChange}
          data={pair.values.data}
          value={pair.values.startValue}
          placeholder={pair.values.placeholder}
        />
      </div>
    );
  }else if(pair.style==`multi-select`){
    return(
      <div className={id+"-"+pair.name+"-dropdown"}>
        <div className={id+"-dropdown-title"}>{pair.title}</div>
        <MultiSelectDropdownBar
        id = {id+"-"+pair.name+"-dropdown-combobox"}
        onFilterChange={pair.values.onFilterChange}
        onChange={pair.values.onChange}
        data={pair.values.data}
        value={pair.values.startValue}
        placeholder={pair.values.placeholder}
        />
      </div>
    );
  }else if(pair.style==`date-time` && onTimeClear!=null){
    return(
      <div className={id+"-"+pair.name+"-dropdown"}>
        <div className={id+"-dropdown-title"}>{pair.title}</div>
        <input type="datetime-local" className={id+"-input"} id={id+"-"+pair.name+"-input"} value={pair.values.startValue} onBlur={pair.values.onChange}></input>
        <button className={id+"-"+pair.name+"-clear-button"} onClick={(e:any)=>onTimeClear(e)}>X</button>
      </div>
    );
  }else if(pair.style==`tel` && onTimeClear!=null){
    return(
      <div className={id+"-"+pair.name+"-dropdown"}>
        <div className={id+"-dropdown-title"}>{pair.title}</div>
        <input type="tel" className={id+"-input"} id={id+"-"+pair.name+"-input"} onBlur={pair.values.onChange} placeholder="800-123-4567" pattern="[0-9]{3}-[0-9]{3}-[0-9]{4}" defaultValue={pair.values.startValue}></input>
      </div>
    );
  }else if(pair.style==`email` && onTimeClear!=null){
    return(
      <div className={id+"-"+pair.name+"-dropdown"}>
        <div className={id+"-dropdown-title"}>{pair.title}</div>
        <input type="email" className={id+"-input"} id={id+"-"+pair.name+"-input"} onBlur={pair.values.onChange} placeholder="username@mailserver.domain" pattern="^\S+@\S+\.\S+$" defaultValue={pair.values.startValue}></input>
      </div>
    );
  }
  else if(pair.style=="popupMessage"){
    const compareWith = id+"-"+pair.name
    console.log("popupMessage values: ",compareWith)
    return(
          <div className={compareWith+"-dropdown"}>
            <div id={compareWith} className={pair.values.errorPopup?"showMyError":"hideMe"}>
            </div>
          </div>
          )
  }
  else{
    return(
      <div className={id+"-"+pair.name+"-dropdown"}>
        <h4>ERROR - {pair.style} Not Found</h4>
      </div>
      );
  }
}